"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FormTotalsFoot = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./FormTotalsFoot.styles.css");

var _helpers = require("../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FormTotalsFoot = /*#__PURE__*/function (_React$Component) {
  _inherits(FormTotalsFoot, _React$Component);

  var _super = _createSuper(FormTotalsFoot);

  function FormTotalsFoot() {
    var _this;

    _classCallCheck(this, FormTotalsFoot);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderRows", function () {
      var _this$props = _this.props,
          isStatic = _this$props.isStatic,
          isInternalView = _this$props.isInternalView;
      var victoryChartRowSpan = isStatic ? 7 : 8;
      var rows = [];
      rows.push( /*#__PURE__*/_react["default"].createElement("tr", {
        key: "victoryChart"
      }, /*#__PURE__*/_react["default"].createElement("th", {
        rowSpan: victoryChartRowSpan,
        className: "hideOnPrint",
        style: {
          paddingRight: '0px'
        }
      }, !isInternalView ? _this.props.victoryChart : null)));
      !isStatic && rows.push( /*#__PURE__*/_react["default"].createElement("tr", {
        "data-html2canvas-ignore": true,
        key: "ageBracketsRow",
        className: "hideOnPrint"
      }, /*#__PURE__*/_react["default"].createElement("th", {
        key: "agesHeader"
      }, "Ages:"), _this.ageBracketsHeaderCompose()));
      rows.push( /*#__PURE__*/_react["default"].createElement("tr", {
        key: "totalAllocationsRow"
      }, /*#__PURE__*/_react["default"].createElement("th", {
        className: "TemplateTableTotals_textAlignment"
      }, "Total Allocation:"), /*#__PURE__*/_react["default"].createElement("th", {
        className: "TemplateTableTotals_showOnPrint"
      }, "\xA0"), _this.totalAllocationsSum()));

      if (!isInternalView) {
        // don't include additional rows when in internal view
        rows.push( /*#__PURE__*/_react["default"].createElement("tr", {
          key: "fundExpenseRatioTotalsRow"
        }, /*#__PURE__*/_react["default"].createElement("th", {
          className: "TemplateTableTotals_textAlignment"
        }, "Est. Underlying Fund Expense:"), /*#__PURE__*/_react["default"].createElement("th", {
          className: "TemplateTableTotals_showOnPrint"
        }, "\xA0"), _this.estimatedFundFeesSum()));
        rows.push( /*#__PURE__*/_react["default"].createElement("tr", {
          key: "plusRow"
        }, /*#__PURE__*/_react["default"].createElement("td", {
          className: "TemplateTableTotals_showOnPrint",
          colSpan: 2,
          key: isStatic ? 'plusRow_static_print' : 'plusRow_ageBased_print'
        }), /*#__PURE__*/_react["default"].createElement("td", {
          "data-html2canvas-ignore": true,
          className: "hideOnPrint",
          key: isStatic ? 'plusRow_static' : 'plusRow_ageBased'
        }), _this.plusRowCompose()));
        rows.push( /*#__PURE__*/_react["default"].createElement("tr", {
          key: "my529AdminFeeRow"
        }, /*#__PURE__*/_react["default"].createElement("th", {
          className: "TemplateTableTotals_textAlignment"
        }, "my529 Admin Asset Fee:"), /*#__PURE__*/_react["default"].createElement("th", {
          className: "TemplateTableTotals_showOnPrint"
        }, "\xA0"), _this.my529AdminFeeSum()));
        rows.push( /*#__PURE__*/_react["default"].createElement("tr", {
          key: "equalRow"
        }, /*#__PURE__*/_react["default"].createElement("td", {
          className: "TemplateTableTotals_showOnPrint",
          colSpan: 2,
          key: isStatic ? 'equalRow_static_print' : 'equalRow_ageBased_print'
        }), /*#__PURE__*/_react["default"].createElement("td", {
          "data-html2canvas-ignore": true,
          className: "hideOnPrint",
          key: isStatic ? 'equalRow_static' : 'equalRow_ageBased'
        }), _this.equalRowCompose()));
        rows.push( /*#__PURE__*/_react["default"].createElement("tr", {
          key: "estTotalFeesRow"
        }, /*#__PURE__*/_react["default"].createElement("th", {
          className: "TemplateTableTotals_textAlignment"
        }, "Est. Total Annual Asset-Based Fee:"), /*#__PURE__*/_react["default"].createElement("th", {
          className: "TemplateTableTotals_showOnPrint"
        }, "\xA0"), _this.estTotalFeesSum()));
      }

      return rows;
    });

    return _this;
  }

  _createClass(FormTotalsFoot, [{
    key: "ageBracketsHeaderCompose",
    value: function ageBracketsHeaderCompose() {
      return this.props.bracketNames.map(function (bracketName) {
        return /*#__PURE__*/_react["default"].createElement("th", {
          key: bracketName,
          className: "TemplateTableTotals_ageBrackets"
        }, bracketName);
      });
    }
  }, {
    key: "my529AdminFeeSum",
    value: function my529AdminFeeSum() {
      var _this2 = this;

      return this.props.bracketNames.map(function (bracket, idx) {
        return /*#__PURE__*/_react["default"].createElement("td", {
          key: "my529AdminFeeRow".concat(bracket)
        }, " ", (0, _helpers.toFixed3)(_this2.props.my529AdminAssetFees[idx]), "% ");
      });
    }
  }, {
    key: "totalAllocationsSum",
    value: function totalAllocationsSum() {
      var _this3 = this;

      return this.props.bracketTotals.map(function (bracketTotal, idx) {
        return /*#__PURE__*/_react["default"].createElement("td", {
          className: parseFloat((0, _helpers.toFixed2)(bracketTotal)) !== 100 ? 'TemplateTableTotals_totalsNot100' : null,
          key: "totalAllocations".concat(_this3.props.bracketNames[idx])
        }, (0, _helpers.toFixed2)(bracketTotal), "%");
      });
    }
  }, {
    key: "estimatedFundFeesSum",
    value: function estimatedFundFeesSum() {
      return this.props.estFundFees.map(function (bracketFeeTotal, idx) {
        return /*#__PURE__*/_react["default"].createElement("td", {
          key: "fundExpenseRatioTotalsRow".concat(idx)
        }, " ", (0, _helpers.toFixed3)(bracketFeeTotal), "%");
      });
    }
  }, {
    key: "plusRowCompose",
    value: function plusRowCompose() {
      return this.props.bracketNames.map(function (bracket) {
        return /*#__PURE__*/_react["default"].createElement("td", {
          key: "plusRow".concat(bracket)
        }, "+");
      });
    }
  }, {
    key: "equalRowCompose",
    value: function equalRowCompose() {
      return this.props.bracketNames.map(function (bracketName) {
        return /*#__PURE__*/_react["default"].createElement("td", {
          key: "equalRow_".concat(bracketName)
        }, "=");
      });
    }
  }, {
    key: "estTotalFeesSum",
    value: function estTotalFeesSum() {
      return this.props.estTotalFees.map(function (estBracketFee, idx) {
        return /*#__PURE__*/_react["default"].createElement("td", {
          key: "estTotalFees".concat(idx)
        }, " ", (0, _helpers.toFixed3)(estBracketFee), "% ");
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("tfoot", {
        className: "TemplateTableTotals_templateTableTotals"
      }, Object.keys(this.props.bracketNames).length > 0 ? this.renderRows() : /*#__PURE__*/_react["default"].createElement("tr", null));
    }
  }]);

  return FormTotalsFoot;
}(_react["default"].Component);

exports.FormTotalsFoot = FormTotalsFoot;

_defineProperty(FormTotalsFoot, "propTypes", {
  isInternalView: _propTypes["default"].bool.isRequired,
  isStatic: _propTypes["default"].bool.isRequired,
  bracketNames: _propTypes["default"].array.isRequired,
  bracketTotals: _propTypes["default"].array.isRequired,
  estFundFees: _propTypes["default"].array.isRequired,
  my529AdminAssetFees: _propTypes["default"].array.isRequired,
  estTotalFees: _propTypes["default"].array.isRequired,
  victoryChart: _propTypes["default"].node.isRequired
});

var _default = FormTotalsFoot;
exports["default"] = _default;